import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

const About = () => {
  const { t } = useTranslation();
  
  return (
    <section className="section-padding" style={{ background: '#fffef2' }}>
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="heading-1 mb-6">{t.about.title}</h2>
          <div className="w-20 h-px bg-gray-300 mx-auto"></div>
        </div>
        
        <div className="max-w-5xl mx-auto">
          <p className="body-large text-center mb-12" style={{ color: '#333333', lineHeight: 1.8 }}>
            {t.about.description}
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mt-20">
            <div className="text-center">
              <h3 className="heading-2 mb-4" style={{ fontSize: '24px' }}>{t.about.directAccess}</h3>
              <p className="body-regular" style={{ color: '#666666' }}>
                {t.about.directAccessDesc}
              </p>
            </div>
            
            <div className="text-center">
              <h3 className="heading-2 mb-4" style={{ fontSize: '24px' }}>{t.about.globalReach}</h3>
              <p className="body-regular" style={{ color: '#666666' }}>
                {t.about.globalReachDesc}
              </p>
            </div>
            
            <div className="text-center">
              <h3 className="heading-2 mb-4" style={{ fontSize: '24px' }}>{t.about.discretion}</h3>
              <p className="body-regular" style={{ color: '#666666' }}>
                {t.about.discretionDesc}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;